import { createContext, useContext } from 'react';

import type { IncidentId, IncidentLiveState, PortalHubConnection } from '@/signalr';

export type IncidentRealtime = {
  readonly incidentId: IncidentId;
  readonly hub: PortalHubConnection;
  getLiveState(): Promise<IncidentLiveState>;
  setChatTranslationsAllowed(allowChatTranslations: boolean): Promise<void>;
  sendDispatcherTextPreview(messagePreview: string): Promise<void>;
  sendDispatcherImagePreview(isSendingImage: boolean): Promise<void>;
  endLiveVideo(): Promise<void>;
  switchCamera(): Promise<void>;
  takeCallerCameraSnapshot(): Promise<void>;
};

export function createIncidentRealtime(hub: PortalHubConnection, incidentId: IncidentId): IncidentRealtime {
  return {
    incidentId,
    hub,
    getLiveState: () => hub.invoke('GetIncidentLiveState', incidentId),
    setChatTranslationsAllowed: (allowChatTranslations) =>
      hub.invoke('SetIsChatTranslationsAllowed', incidentId, allowChatTranslations),
    sendDispatcherTextPreview: (messagePreview) =>
      hub.invoke('SendDispatcherChatTextMessagePreview', incidentId, messagePreview),
    sendDispatcherImagePreview: (isSendingImage) =>
      hub.invoke('SendDispatcherChatImageMessagePreview', incidentId, isSendingImage),
    endLiveVideo: () => hub.invoke('EndLiveVideo', incidentId),
    switchCamera: () => hub.invoke('SwitchCameraRequest', incidentId),
    takeCallerCameraSnapshot: () => hub.invoke('TakeCallerCameraSnapshot', incidentId),
  };
}

export const IncidentRealtimeContext = createContext<IncidentRealtime | null>(null);

export function useIncidentRealtime(): IncidentRealtime | null {
  return useContext(IncidentRealtimeContext);
}
